module.exports = __webpack_public_path__ + "img/sample-report-06@3x.0f77d9ed.png";